import React from "react";
import { Link } from "react-router-dom";

const Pagination = (props) => {
  // page number list based on total number of pages
  const pageNumbers = [];
  const totalPosts = props.data.length;
  const totalPages = Math.ceil(totalPosts / props.postPerPage);
  const isFirstPage = props.currentPage === 1;
  const isLastPage = props.currentPage === totalPages;

  for (let i = 1; i <= Math.ceil(totalPosts / props.postPerPage); i++) {
    pageNumbers.push(i);
  }

  const prevPage = (e) => {
    if (isFirstPage) {
      e.preventDefault();
    } else {
      if (props.currentPage !== 1) {
        props.setCurrentPage(props.currentPage - 1);
      }
    }
  };

  const nextPage = (e) => {
    if (isLastPage) {
      e.preventDefault();
    } else {
      if (props.currentPage !== pageNumbers) {
        props.setCurrentPage(props.currentPage + 1);
      }
    }
  };

  return (
    <nav>
      <ul className="pagination justify-content-center">
        <li className="page-item">
          <Link
            className={isFirstPage ? "disabled-link" : "page-link"}
            onClick={prevPage}
            aria-disabled={isFirstPage}
            href="#"
          >
            Previous
          </Link>
        </li>
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={
              props.currentPage === number ? "page-item active" : "page-item"
            }
          >
            <Link
              onClick={() => props.setCurrentPage(number)}
              className="page-link"
            >
              {number}
            </Link>
          </li>
        ))}
        <li className="page-item">
          <Link
            // className="page-link"
            className={isLastPage ? "disabled-link" : "page-link"}
            aria-disabled={isLastPage}
            onClick={nextPage}
            href="#"
          >
            Next
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
